import AuthenticatedResource from 'resources/AuthenticatedResource'

export default class OfferInstanceDownloadResource extends AuthenticatedResource {
  static urlRoot = 'organizations/:organization_id/offer_instances/download' as const;

  pk() {
    return 'download';
  }
}
